import Backbone from 'backbone';
import Notice from './notice';

const Notices = Backbone.Collection.extend({
  model: Notice,
  parse(response) {
    if (response && !Array.isArray(response)) {
      return Object.values(response);
    }
    return response;
  },
});

export default Notices;



/** WEBPACK FOOTER **
 ** ./src/models/notices.js
 **/